var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _rect, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTask(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 21.6981C16.299 21.6981 21 16.8408 21 10.8491C21 4.85729 16.299 0 10.5 0C4.70101 0 0 4.85729 0 10.8491C0 16.8408 4.70101 21.6981 10.5 21.6981Z",
    fill: "#0497AE"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.58
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.58
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.21494 10.6275L2.41361 10.8268L3.15654 10.0814",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.58
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.12866 10.7545L4.25433 10.8796L4.72468 10.4077",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.58
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1474 8.53868L13.3451 8.73801L14.0881 7.99261",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.58
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6177 18.7582L13.8155 18.9566L14.5584 18.2112",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.58
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6882 14.7504L17.8859 14.9488L18.6289 14.2034",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.58
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5601 6.34143L15.671 6.45268L16.0859 6.03641",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.58
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5989 10.1639L15.6931 10.2585L16.047 9.9034",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.58
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.34 17.6272L11.4342 17.7217L11.7881 17.3666",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.58
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00949 1.35543L9.10467 1.44999L9.45766 1.09491",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.58
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8514 9.06434L15.111 9.32486L16.0859 8.34676",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.58
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1585 10.3836L18.4182 10.6442L19.393 9.66606",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.58
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0607 12.0469L17.143 12.1294L17.4498 11.8207",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.58
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8398 19.8837L11.9221 19.9663L12.2289 19.6575",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.58
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1452 11.5008L15.3429 11.6992L16.0859 10.9538",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.58
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0933 2.45312L11.291 2.65153L12.0349 1.90613",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.58
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M3.95123 12.8451L4.2765 13.1724L5.49902 11.9458",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.58
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M9.67111 19.3414L9.99638 19.6677L11.2189 18.4421",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.58
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3932 3.55083L13.7185 3.87718L14.941 2.65154",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.58
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M4.71542 15.5653L4.79212 15.6422L5.0795 15.3548",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.58
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M7.03201 19.7354L7.10871 19.8123L7.39609 19.524",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.58
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M3.46057 14.3062L3.57793 14.424L4.01777 13.9818",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.58
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M4.80045 17.5419L4.9178 17.6596L5.35765 17.2183",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.58
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M5.94904 5.87788L6.14678 6.07628L6.88972 5.33089",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.58
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M5.64963 3.06595L5.84737 3.26435L6.59031 2.51895",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.58
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M7.76294 4.46219L7.88399 4.58456L8.3414 4.12657",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.58
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M3.83942 5.43748L3.96139 5.55986L4.41787 5.10094",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.24
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.24
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M1.45169 10.087L1.64944 10.2854L2.39238 9.53996",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.24
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M3.36447 10.213L3.49014 10.3391L3.96141 9.86723",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.24
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3832 7.99818L12.581 8.19751L13.3239 7.45119",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.24
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8536 18.2177L13.0513 18.4161L13.7952 17.6707",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.24
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M16.924 14.2098L17.1227 14.4082L17.8656 13.6628",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.24
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7959 5.80093L14.9068 5.91218L15.3217 5.49498",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.24
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8347 9.62342L14.929 9.71798L15.2829 9.3629",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.24
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5758 17.0867L10.67 17.1803L11.0239 16.8261",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.24
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M8.24625 0.814916L8.3405 0.909481L8.69349 0.554398",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.24
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0881 8.52291L14.3477 8.78343L15.3217 7.80533",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.24
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3953 9.84221L17.6549 10.1027L18.6289 9.12555",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.24
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2966 11.5064L16.3788 11.5889L16.6856 11.2802",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.24
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0757 19.3433L11.1579 19.4258L11.4647 19.117",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.24
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M14.381 10.9594L14.5788 11.1587L15.3217 10.4133",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.24
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3291 1.91168L10.5277 2.11101L11.2707 1.36469",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.24
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M3.18707 12.3046L3.51326 12.631L4.73486 11.4053",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.24
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M8.90692 18.8009L9.23311 19.1272L10.4547 17.9016",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.24
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M12.629 3.01032L12.9543 3.33666L14.1768 2.11102",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.24
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M3.95218 15.0248L4.02795 15.1017L4.31533 14.8134",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.24
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M6.26782 19.1949L6.34452 19.2709L6.6319 18.9835",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.24
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M2.69638 13.7657L2.81374 13.8835L3.25451 13.4413",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.24
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M4.03625 17.0014L4.15361 17.1191L4.59438 16.6769",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.24
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M5.18484 5.33644L5.38259 5.53577L6.12553 4.78944",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.24
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M4.88547 2.52543L5.08321 2.72384L5.82615 1.97844",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.24
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99878 3.92166L7.12075 4.04403L7.57724 3.58511",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.24
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M3.07526 4.89698L3.19723 5.01843L3.65371 4.56044",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.12
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.12
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M1.09222 11.269L1.28997 11.4674L2.03291 10.722",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.12
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M3.00595 11.3951L3.1307 11.5212L3.60196 11.0484",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.12
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0237 9.18023L12.2215 9.37864L12.9654 8.63324",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.12
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4941 19.3989L12.6928 19.5973L13.4357 18.8519",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.12
  }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5655 15.391L16.7632 15.5894L17.5062 14.844",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.12
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4374 6.98299L14.5473 7.09332L14.9632 6.67705",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.12
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4762 10.8045L14.5704 10.8991L14.9234 10.544",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.12
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2163 18.2678L10.3106 18.3624L10.6645 18.0073",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.12
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M7.88678 1.99605L7.98103 2.09062L8.33494 1.73553",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.12
  }, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7286 9.70498L13.9883 9.9655L14.9632 8.9874",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.12
  }, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0358 11.0243L17.2955 11.2848L18.2704 10.3067",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.12
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M15.938 12.6875L16.0194 12.77L16.3271 12.4622",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.12
  }, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7172 20.5244L10.7985 20.6069L11.1062 20.2991",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.12
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0215 12.1414L14.2202 12.3398L14.9631 11.5944",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.12
  }, _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M9.97052 3.09376L10.1683 3.29217L10.9112 2.54677",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.12
  }, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M2.82761 13.4857L3.1538 13.813L4.37539 12.5864",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.12
  }, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5484 19.982L8.87367 20.3084L10.0953 19.0827",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.12
  }, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2695 4.19146L12.5957 4.5178L13.8173 3.29216",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.12
  }, _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M3.59271 16.2059L3.66848 16.2828L3.95586 15.9954",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.12
  }, _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M5.9093 20.376L5.986 20.453L6.27245 20.1647",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.12
  }, _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M2.33691 14.9469L2.45427 15.0646L2.89504 14.6233",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.12
  }, _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M3.67679 18.1825L3.79414 18.3012L4.23492 17.8589",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.12
  }, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M4.82538 6.51756L5.02313 6.71689L5.76699 5.9715",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.12
  }, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M4.526 3.70657L4.72467 3.90497L5.46761 3.15958",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.12
  }, _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M6.63931 5.10281L6.76129 5.22519L7.21777 4.7672",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.12
  }, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M2.71671 6.07812L2.83776 6.2005L3.29516 5.74251",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.69916,
    y: 2.07579,
    width: 16.1709,
    height: 18.0787,
    fill: "url(#pattern0)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0248 3.52672L9.64523 6.49811L8.02814 6.87637L11.0248 3.52672Z",
    fill: "url(#paint0_linear_25_1111)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8521 3.79L9.61014 6.45823L8.16123 6.79848C9.05756 5.79535 9.95451 4.79252 10.8521 3.79ZM11.1977 3.26433L7.89603 6.95238L9.6776 6.53518L11.1977 3.26155V3.26433Z",
    fill: "#772621"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4675 6.56022L11.2549 3.42195C11.713 4.05985 12.1247 4.73003 12.4867 5.42729C12.7288 5.89085 12.9487 6.37758 13.1446 6.86432L13.1298 6.93756L11.4675 6.56022Z",
    fill: "url(#paint1_linear_25_1111)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3122 3.58234C11.7311 4.17843 12.1099 4.80191 12.446 5.44862C12.6854 5.91217 12.9034 6.38778 13.0929 6.86802V6.88193L11.51 6.52221L11.3113 3.58234H11.3122ZM11.1967 3.26434L11.4222 6.60194L13.164 6.99689L13.1917 6.86339C13.0069 6.40539 12.7898 5.91773 12.5274 5.40968C12.1393 4.66259 11.6944 3.9466 11.1967 3.26805V3.26434Z",
    fill: "#772621"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M9.4364 15.7831L11.4582 6.65294L13.1104 7.02378L12.4636 10.1018C11.9923 12.3386 11.5211 14.576 11.0498 16.8141L9.4364 15.7831Z",
    fill: "url(#paint2_linear_25_1111)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4934 6.70856L13.0559 7.06272L12.361 10.3586L11.0166 16.7427L9.48817 15.7599L11.4934 6.70763V6.70856ZM11.4231 6.59731L9.38467 15.8035L11.0794 16.892C11.7743 13.5921 12.4695 10.2922 13.165 6.99225L11.4231 6.59731Z",
    fill: "#772621"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M5.84369 15.7154C6.54042 12.8105 7.23747 9.90338 7.93482 6.99411L9.61659 6.60008L7.63542 15.4151L5.84369 15.7154Z",
    fill: "url(#paint3_linear_25_1111)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5547 6.66221L7.59756 15.3771L5.9047 15.658L7.97272 7.03584L9.5547 6.66499V6.66221ZM9.6776 6.54076L7.89603 6.9524C7.19067 9.8932 6.48593 12.8334 5.7818 15.7729L7.67426 15.4549L9.6776 6.53798V6.54076Z",
    fill: "#772621"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M5.85757 15.8072L7.62344 15.5106L7.38688 18.2984L5.85757 15.8072Z",
    fill: "url(#paint4_linear_25_1111)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M7.57169 15.5662L7.35269 18.1538L6.67998 17.0579L5.93334 15.8406L7.57169 15.5625V15.5662ZM7.67426 15.4512L5.7818 15.7692C6.32884 16.658 6.87526 17.5477 7.42107 18.4384L7.67426 15.4512Z",
    fill: "#772621"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M9.39575 15.8666L10.9805 16.8845L7.55966 18.3327L9.39575 15.8666Z",
    fill: "url(#paint5_linear_25_1111)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M9.40684 15.9287L10.8853 16.8762L9.71455 17.3713L7.70289 18.2233L9.41054 15.9287H9.40684ZM9.38836 15.8045L7.42105 18.4421L11.0794 16.8929L9.38466 15.8045H9.38836Z",
    fill: "#772621"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M9.74875 6.49439L11.1635 3.44698L11.3742 6.55002L9.74875 6.49439Z",
    fill: "url(#paint6_linear_25_1111)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1302 3.63055L11.3243 6.5046L9.82084 6.45268L11.1302 3.63333V3.63055ZM11.1977 3.26249L9.67761 6.53798L11.4231 6.59824L11.1977 3.26064V3.26249Z",
    fill: "#772621"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M7.72968 15.4188L9.71454 6.5862L11.3658 6.64275L9.34861 15.7498L7.72968 15.4188Z",
    fill: "url(#paint7_linear_25_1111)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M9.7506 6.63347L11.3095 6.68632L9.31352 15.6951L7.78514 15.3836L9.7506 6.63347ZM9.6776 6.54076L7.67426 15.4549L9.38468 15.8045L11.4231 6.59824L9.6776 6.53798V6.54076Z",
    fill: "#772621"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M7.71582 15.5115L9.30334 15.835L7.48111 18.2845L7.71582 15.5115Z",
    fill: "url(#paint8_linear_25_1111)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M7.76204 15.5671L9.22759 15.8656L7.54027 18.1269L7.76204 15.5671ZM7.67888 15.4549L7.42569 18.4421L9.3893 15.8044L7.67888 15.4549Z",
    fill: "#772621"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M3.98083 7.72189L4.43454 7.20178L4.78753 7.8146L3.98083 7.72189Z",
    fill: "url(#paint9_linear_25_1111)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M4.42622 7.28058L4.70343 7.75804L4.07508 7.68572L4.23679 7.5003L4.42807 7.28058H4.42622ZM4.44377 7.12204C4.25896 7.33466 4.07415 7.54666 3.88934 7.75804L4.87438 7.87115L4.44285 7.12204H4.44377Z",
    fill: "#772621"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M4.90672 7.83501L4.53802 7.19623L8.75447 8.34028L7.36378 8.96608L4.90672 7.83501Z",
    fill: "url(#paint10_linear_25_1111)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M4.63413 7.2704L6.37597 7.74323L8.61679 8.35142L7.36378 8.9151L4.93907 7.80257L4.63413 7.27411V7.2704ZM4.44193 7.12577L4.87346 7.87488L7.36378 9.01708L8.89123 8.33009L4.44193 7.12485V7.12577Z",
    fill: "#772621"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M3.96786 7.81367L4.84756 7.91473L6.51825 10.3373L6.11998 12.0867L3.96786 7.81367Z",
    fill: "url(#paint11_linear_25_1111)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M4.04735 7.86931L4.8217 7.96202L6.46836 10.3465L6.09874 11.9505L4.04273 7.87116L4.04735 7.86931ZM3.88379 7.75991L6.1357 12.2221L6.56816 10.3271L4.87345 7.87116L3.88841 7.75806L3.88379 7.75991Z",
    fill: "#772621"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M7.45526 9.02634L8.88477 8.38385L15.7154 13.8316L15.5804 14.9969L7.45526 9.02634Z",
    fill: "url(#paint12_linear_25_1111)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M8.87829 8.43578L15.6664 13.8492L15.5444 14.9107L7.54673 9.03655L8.87829 8.43578ZM8.89123 8.32823L7.36377 9.01708L15.6165 15.0813L15.7643 13.813L8.89123 8.33009V8.32823Z",
    fill: "#772621"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M6.19116 12.2045L6.60052 10.4087L14.6924 16.6546L12.7288 17.489L6.19116 12.2045Z",
    fill: "url(#paint13_linear_25_1111)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M6.62546 10.4893L14.6046 16.6435L12.739 17.4371L6.23921 12.1859L6.62546 10.4893ZM6.56817 10.3271L6.13571 12.2221L12.7242 17.5437L14.7848 16.6667L6.56817 10.3271Z",
    fill: "#772621"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8924 17.5214L14.7849 16.7186L16.9564 18.1343L12.8924 17.5214Z",
    fill: "url(#paint14_linear_25_1111)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7774 16.7714L16.7494 18.0564L13.0615 17.5001L14.7774 16.7705V16.7714ZM14.7867 16.6657L12.7242 17.5428L17.1596 18.2103L14.7848 16.6667L14.7867 16.6657Z",
    fill: "#772621"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6655 15.0739L15.7856 14.0309L16.9286 17.6411L15.6655 15.0739Z",
    fill: "url(#paint15_linear_25_1111)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8068 14.2506L16.6994 17.0709L15.7089 15.0655L15.8013 14.2506H15.8068ZM15.7643 13.813L15.6165 15.0813L17.1559 18.2112L15.7643 13.813Z",
    fill: "#772621"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M6.60144 10.2956L5.00745 7.98334L7.33975 9.05693L15.5583 15.0952L14.771 16.5962L6.60144 10.2956Z",
    fill: "url(#paint16_linear_25_1111)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M5.14142 8.09644L7.31664 9.0968L15.4991 15.111L14.7599 16.5276L6.63561 10.2631L5.14142 8.09644ZM4.87344 7.87115L6.56815 10.3271L14.7848 16.6667L15.6165 15.0813L7.36376 9.01706L4.87344 7.87115Z",
    fill: "#772621"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8467 16.6509L15.6165 15.1833L17.0414 18.0805L14.8467 16.6509Z",
    fill: "url(#paint17_linear_25_1111)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6165 15.2862L16.9277 17.9498L14.9096 16.6351L15.6165 15.2862ZM15.6165 15.0813L14.7849 16.6667L17.155 18.2112L15.6165 15.0813Z",
    fill: "#772621"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_25_1111",
    transform: "scale(0.00571429 0.00512821)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_25_1111",
    x1: 8.02814,
    y1: 5.20201,
    x2: 11.0248,
    y2: 5.20201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F17067"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B23931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_25_1111",
    x1: 11.2549,
    y1: 5.17975,
    x2: 13.1446,
    y2: 5.17975,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F17067"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B23931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_25_1111",
    x1: 9.4364,
    y1: 11.7354,
    x2: 13.1104,
    y2: 11.7354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F17067"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B23931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_25_1111",
    x1: 5.84369,
    y1: 11.1578,
    x2: 9.61659,
    y2: 11.1578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F17067"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B23931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_25_1111",
    x1: 5.85757,
    y1: 16.904,
    x2: 7.62344,
    y2: 16.904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F17067"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B23931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_25_1111",
    x1: 7.55966,
    y1: 17.0996,
    x2: 10.9805,
    y2: 17.0996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F17067"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B23931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_25_1111",
    x1: 9.74875,
    y1: 4.99896,
    x2: 11.3742,
    y2: 4.99896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F17067"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B23931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_25_1111",
    x1: 7.72968,
    y1: 11.168,
    x2: 11.3658,
    y2: 11.168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F17067"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B23931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_25_1111",
    x1: 7.48111,
    y1: 16.8975,
    x2: 9.30334,
    y2: 16.8975,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F17067"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B23931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_25_1111",
    x1: 3.98083,
    y1: 7.50773,
    x2: 4.78753,
    y2: 7.50773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F17067"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B23931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_25_1111",
    x1: 4.53802,
    y1: 8.08069,
    x2: 8.75447,
    y2: 8.08069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F17067"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B23931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_25_1111",
    x1: 3.96786,
    y1: 9.94974,
    x2: 6.51825,
    y2: 9.94974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F17067"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B23931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_25_1111",
    x1: 7.45526,
    y1: 11.6909,
    x2: 15.7154,
    y2: 11.6909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F17067"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B23931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_25_1111",
    x1: 6.18747,
    y1: 13.9493,
    x2: 14.6952,
    y2: 13.9493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F17067"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B23931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_25_1111",
    x1: 12.8924,
    y1: 17.426,
    x2: 16.9536,
    y2: 17.426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F17067"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B23931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_25_1111",
    x1: 15.6655,
    y1: 15.836,
    x2: 16.9286,
    y2: 15.836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F17067"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B23931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_25_1111",
    x1: 5.00745,
    y1: 12.2898,
    x2: 15.5583,
    y2: 12.2898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F17067"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B23931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_25_1111",
    x1: 14.8467,
    y1: 16.6324,
    x2: 17.0414,
    y2: 16.6324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F17067"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B23931"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_25_1111",
    width: 175,
    height: 195,
    xlinkHref: "data:image/png;base64,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"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTask);
export default __webpack_public_path__ + "static/media/task.e42b12f418ddd4b89a15352533fcc415.svg";
export { ForwardRef as ReactComponent };